import * as React from "react";

const BrokerAuthError = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#EEF2F7",
      }}
    >
      <div
        style={{
          width: "400px",
          textAlign: "center",
          height: "400px",
          backgroundColor: "#ffff",
        }}
        className={"login-form"}
      >
        <p
          style={{
            backgroundColor: "#192853",
            marginTop: "0px",
            padding: "10px",
          }}
        >
          <img
            src={"/Logo_white.svg"}
            alt={"PrestigePEO logo"}
            style={{ height: 45 }}
          />
        </p>
        <h2>Auth Error</h2>
        <p style={{ padding: "40px" }}>
          Error occurred while authenticating. Please contact PrestigePEO
          support.
        </p>
      </div>
    </div>
  );
};

export default BrokerAuthError;
